import { mapMutations } from 'vuex';

import { ProgressFooterToolbar } from 'ipro-ui-kit-vuejs/src/components';
import { DNAService } from '@/core/dna';
import { OneTimePassService } from '@/core/one-time-pass';
import { WorkerOnBoardingRoutesMixin } from '@/portal/worker-on-boarding/mixins';

// @vue/component
export default {
  components: {
    ProgressFooterToolbar,
  },
  mixins: [
    WorkerOnBoardingRoutesMixin,
  ],
  data() {
    return {
      oneTimePass: null,
      options: null,
      requestInProgress: false,
      searchText: '',
      selectedOption: _.get(this.$store.state, 'workerOnBoarding.selectedBusiness', null),
    };
  },
  computed: {
    countryCode() {
      return _.get(this.oneTimePass, 'client.country.iso_code');
    },
    clientName() {
      return _.get(this.oneTimePass, 'client.trading_names[0].name');
    },
    displayedOptions() {
      const newBusinessOption = {
        id: '',
        businessName: this.searchText,
        createNew: true,
      };
      return [
        ...(this.thresholdCrossed && !!this.options && !this.requestInProgress ? [newBusinessOption] : []),
        ...(this.selectedOption ? [this.selectedOption] : []),
        ...(this.thresholdCrossed && !this.requestInProgress ? this.options || [] : []),
      ];
    },
    thresholdCrossed() {
      return !!this.searchText && this.searchText.length >= 3;
    },
  },
  watch: {
    searchText() {
      this.searchBusinesses();
    },
  },
  created() {
    this.fetchOneTimePass();
  },
  methods: {
    ...mapMutations('workerOnBoarding', ['setSelectedBusiness']),
    async fetchOneTimePass() {
      const {
        client_uuid: clientUuid,
        location_uuid: locationUuid,
      } = this.$route.query;
      if (clientUuid && locationUuid) {
        this.oneTimePass = await OneTimePassService.get(clientUuid, locationUuid);
      }
    },
    searchBusinesses: _.debounce(async function () {
      if (this.thresholdCrossed) {
        try {
          this.requestInProgress = true;
          const rawOptions = await DNAService.search(this.searchText, this.countryCode);
          this.options = rawOptions.map(entity => ({
            id: entity.id,
            businessName: entity.businessName,
            address: entity.address,
            uuid: entity.uuid,
          }));
        } catch (error) {
          // Do nothing
        } finally {
          this.requestInProgress = false;
        }
      } else if (_.get(this.options, 'length')) {
        this.options = null;
      }
    }, 250),
    redirect() {
      const selectedBusiness = this.selectedOption;
      if (selectedBusiness) {
        this.$router.push(selectedBusiness.createNew || !selectedBusiness.uuid ? this.routes.unregisteredBusiness : this.routes.requestAccess);
      }
    },
    selectBusiness() {
      this.setSelectedBusiness(this.selectedOption);
      this.redirect();
    },
  },
};
